import { Component, OnInit, Inject } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Zone, BoothType, Constituency, Ward, LocationCategory } from './../booth-interface.service';
import { GlobalValidationService } from 'src/app/global-validation.service';
import { HttpService } from 'src/app/http.service';
import { BoothService } from '../booth.service';


@Component({
  selector: 'app-booth-register-popup',
  templateUrl: './booth-register-popup.component.html',
  styleUrls: ['./booth-register-popup.component.scss']
})
export class BoothRegisterPopupComponent {

  booth_register_form: FormGroup;
  zones: Zone[] = [];
  booth_types: BoothType[] = [];
  constituencies: Constituency[] = [];
  wards: Ward[] = [];
  isLinear = false;
  booth_name: any;
  product_price = {};
  location_categories: LocationCategory[] = [];
  products: any;
  display_product_prices: boolean = false;
  name_available = false;
  name_available_already = false;
  update_option = false;
  action: string;
  code_generated = false;
  showError: boolean;

  constructor(public dialogRef: MatDialogRef<BoothRegisterPopupComponent>,
    @Inject(MAT_DIALOG_DATA) private global: GlobalService, private formBuilder: FormBuilder, private http: HttpService, private boothService: BoothService) {
    console.log('booth register constructor run');
    this.booth_register_form = this.formBuilder.group({
      id: [null],
      name: [null, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])],
      zone_id: [null, Validators.compose([Validators.required])],
      business_type_id: [null, Validators.compose([Validators.required])],
      constituency_id: [null, Validators.compose([Validators.required])],
      ward_id: [null, Validators.compose([Validators.required])],
      address: [null, Validators.compose([Validators.required])],
      is_rural: [false],
      location_category_id: [null, Validators.compose([Validators.required])],
      pincode: [null, Validators.compose([GlobalValidationService.checkPincode])],
      location_category_value: [null, Validators.compose([Validators.required])],
      landmark: [null],
      working_hours_from: ['09:00'],
      working_hours_to: ['06:00'],
    });

    this.getFormCvs();
  }

  getFormCvs() {
    this.getZones();
    this.getBusinessTypes();
    this.getConstituencies();
    this.getWards();
    this.getLocationCategories();
    this.getProducts();

  }

  getProducts() {
    this.http.getProductwithMrp().subscribe((data) => {
      console.log(data);
      this.products = data;
      this.generateProductPriceDict();
    })
  }

  generateProductPriceDict() {
    this.product_price = {}
    // this.products.forEach(element => {
    //   this.product_price[element.name]=0
    // });
  }

  activateBoothDetail() {
    if (this.booth_register_form.controls.zone_id.valid && this.booth_register_form.controls.constituency_id.valid && this.booth_register_form.controls.ward_id.valid &&
      this.booth_register_form.controls.address.valid && this.booth_register_form.controls.location_category_id.valid && this.booth_register_form.controls.location_category_value.valid
      && this.booth_register_form.controls.pincode.valid && this.booth_register_form.controls.is_rural.valid ) {
      return false;
    }
    else {
      return true;
    }
  }

  // generateCode() {
  //   const data_dict = {
  //     'business_type_id': this.booth_register_form.value['business_type_id']
  //   }
  //   console.log(data_dict);
  //   this.http.generateBoothCode(data_dict).subscribe((data) => {
  //     console.log(data);
  //     this.booth_register_form.controls['code'].setValue(data);
  //     this.code_generated = true
  //   })
  // }

  checkCode() {
    const data_dict = {
      'business_code': this.booth_register_form.value.code
    }
    console.log(data_dict);
    this.http.generateBoothCode(data_dict).subscribe((data) => {
      console.log(data);
      if (!data) {
        this.code_generated = true;
        this.showError = false;
      }
      else {
        this.showError = true;
        this.code_generated = false;
        this.booth_register_form.controls['code'].setValue(null);
      }
    })
  }

  getZones() {
    this.http.getZones().subscribe((data: Zone[]) => {
      console.log(data);
      this.zones = data;
    }, (error) => {
      console.log(error);
    });
  }

  onChange(event) {
    console.log(event)
    this.product_price = {}
    this.generateProductPriceDict();
    if (event == 4 || event == 5 || event == 6) {
      this.display_product_prices = true;
      if (event == 4) {
        this.products.forEach((data) => {
          if (data.private_institute_price != null) {
            this.product_price[data.id] = data.private_institute_price
          }
        })
      }
      if (event == 5) {
        this.products.forEach((data) => {
          if (data.govt_institute_price != null) {
            this.product_price[data.id] = data.govt_institute_price
          }
        })
      }
      console.log(this.product_price);
    }
    else {
      this.display_product_prices = false;
      this.product_price = {}
    }
    this.code_generated = false;
    this.booth_register_form.controls['code'].setValue(null);
  }

  displayProducts() {
    console.log(this.product_price)
  }

  getBusinessTypes() {
    this.http.getBoothTypes().subscribe((data: BoothType[]) => {
      console.log(data);
      this.booth_types = data;
    }, (error) => {
      console.log(error);
    });
  }

  getConstituencies() {
    this.http.getConstituency().subscribe((data: Constituency[]) => {
      console.log(data);
      this.constituencies = data;
    }, (error) => {
      console.log(error);
    });
  }

  getWards() {
    this.http.getWardsBasedOnConstituency().subscribe((data: any) => {
      this.wards = data;
      console.log(data);
    })
    // this.http.getWards().subscribe((data: Ward[]) => {
    //   console.log(data);
    // }, (error) => {
    //   console.log(error);
    // });
  }

  getLocationCategories() {
    this.http.getLocationCategories().subscribe((data: LocationCategory[]) => {
      console.log(data);
      this.location_categories = data;
    }, (error) => {
      console.log(error);
    });
  }


  registerBooth() {
    console.log(this.booth_register_form.value)
    this.booth_register_form.value['product_price'] = this.product_price
    this.http.registerBooth(this.booth_register_form.value).subscribe((data) => {
      console.log(data);
      this.closeComponent(this.booth_register_form.value['code'])
      this.booth_register_form.reset();
      this.global.showSnakeBar(data['message']);
    }, (error) => {
      console.log(error);
    });
  }



  closeComponent(data: any) {
    this.dialogRef.close(data);
  }


}
